import React, { Component } from "react";
import ZPartnerLSC0Header from "./ZPartnerLSC0Header";
import ZPartnerLSC0Footer from "./ZPartnerLSC0Footer";

export class LSC_Index extends Component {
    static displayName = LSC_Index.name;

    constructor(props) {
        super(props);
        this.state = {
            message: "index"            
        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/lsc/style_01.css",
            "/css/lsc/style_02.css",
            "/css/lsc/style_03.css",
            "/css/lsc/691208892_en-US.css",
            "/css/lsc/line_my_card.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });
    }
    
    render() {
        const {
            message
        } = this.state;

        return (
            <div id="js-content" className="account_area new_sr line_my_card">
                <ZPartnerLSC0Header />

                <div className="height-100">
                    <main
                        id="content"
                        className="base___8qAal height-100 flex flex-column"
                        role="main"
                    >
                        {/* Header */}
                        <div className="sb-headerCrate flex flex-column bg-white flex-shrink-none">
                            <div className="lg-flex flex-column base___46s3P">
                                <div className="flex flex-grow flex-column">
                                    <div className="container--headerCrate sb-headerCrate--content size12of12 pt3">
                                        <h2 className="sb-heading sb-heading--medium Sarabun_fontthai">
                                            เข้าสู่ระบบ 🌟
                                        </h2>
                                        <h2 className="sb-heading sb-heading--small">Sign in</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content */}
                        <div className="sb-contentCrate flex-grow">
                            <div className="relative flex-auto">
                                <div className="flex-auto">
                                    <div className="padding___2PNk5 mx-auto narrow___pLMqt pb5">
                                        {message}
                                    </div>
                                </div>
                            </div>

                            <hr
                                aria-hidden="true"
                                className="sb-rule sb-rule--thin mb4 lg-mb6"
                            />

                            {/* Footer */}
                            <ZPartnerLSC0Footer />
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}
